<template>
  <router-view/>
</template>

<script>
export default {
  computed: {
    pageTitle() {
      return this.$t("Green Pages");
    }
  },
  watch: {
    pageTitle(newTitle) {
      document.title = newTitle;
    }
  },
  mounted() {
    document.title = this.pageTitle;
  }
};
</script>